module.exports = __webpack_public_path__ + "static/media/203-niger.d8a0a3f3.svg";